// gb-search-overlay.js
// Such-Overlay: Live-Predictive-Search + "Zuletzt angesehen" (localStorage)
// Ausgelagert in eine externe Datei, weil Inline-<script>-Blöcke auf dieser
// Seite aus irgendeinem Grund nicht zuverlässig ausgeführt werden (z.B. CSP
// oder ein Prozess der den Header nachträglich per innerHTML neu einfügt).
// Externe Dateien mit <script src="..."> sind davon nicht betroffen.

// FIX: Die Suche wurde bisher relativ ("/search/suggest.json") aufgerufen.
// Ohne Markt-Prefix (z.B. "/de-at/") liefert Shopify erst einen 302-Redirect
// auf die lokalisierte URL, und beim Umschreiben dieses Redirects wird
// "resources[type]=product" fehlerhaft neu kodiert -> 422 "expected String
// to be a Hash: resources". Ergebnis: die Suche findet nie etwas, egal was
// man eingibt. Fix: den aktuellen Markt-Root (Shopify.routes.root, z.B.
// "/de-at/") selbst voranstellen, damit kein Redirect mehr nötig ist.

(function () {
  var RECENT_KEY = 'gb_recently_viewed';
  var overlaySelector = '[data-gb-search-overlay]';
  var debounceTimer;
  var moneyFormat = window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR';

  // Shopify.routes.root enthält bereits das aktuelle Markt-Prefix (z.B. "/de-at/")
  // und endet immer mit einem Slash. Fällt auf "/" zurück, falls aus irgendeinem
  // Grund nicht verfügbar (z.B. sehr altes/individuelles Theme-Setup).
  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var value = cents / 100;
    try {
      return new Intl.NumberFormat('de-AT', { style: 'currency', currency: moneyFormat }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + moneyFormat;
    }
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHtml(p) {
    return '<a href="' + p.url + '" class="gb-search-card">' +
      '<span class="gb-search-card__img">' + (p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</span>' +
      '<p class="gb-search-card__title">' + escapeHtml(p.title) + '</p>' +
      '<p class="gb-search-card__price">' + p.priceText + '</p>' +
    '</a>';
  }

  function getOverlayEls() {
    var overlay = document.querySelector(overlaySelector);
    if (!overlay) return null;
    return {
      overlay: overlay,
      input: overlay.querySelector('[data-gb-search-input]'),
      recentSection: overlay.querySelector('[data-gb-search-recent]'),
      recentGrid: overlay.querySelector('[data-gb-search-recent-grid]'),
      resultsSection: overlay.querySelector('[data-gb-search-results]'),
      resultsGrid: overlay.querySelector('[data-gb-search-results-grid]'),
      emptyEl: overlay.querySelector('[data-gb-search-empty]')
    };
  }

  function renderRecent() {
    var els = getOverlayEls();
    if (!els) return;
    var ids;
    try { ids = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { ids = []; }
    if (!ids.length) { els.recentSection.hidden = true; return; }

    var fetches = ids.slice(0, 4).map(function (handle) {
      return fetch(routeRoot + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      var freshEls = getOverlayEls();
      if (!freshEls) return;
      var valid = products.filter(Boolean);
      if (!valid.length) { freshEls.recentSection.hidden = true; return; }
      freshEls.recentGrid.innerHTML = valid.map(function (p) {
        return cardHtml({
          url: routeRoot + 'products/' + p.handle,
          image: p.featured_image,
          title: p.title,
          priceText: money(p.price)
        });
      }).join('');
      freshEls.recentSection.hidden = false;
    });
  }

  function runSearch(term) {
    var els = getOverlayEls();
    if (!els) return;
    if (!term) {
      els.resultsSection.hidden = true;
      els.emptyEl.hidden = true;
      renderRecent();
      return;
    }
    fetch(routeRoot + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var freshEls = getOverlayEls();
        if (!freshEls) return;
        freshEls.recentSection.hidden = true;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          freshEls.resultsSection.hidden = true;
          freshEls.emptyEl.hidden = false;
          return;
        }
        freshEls.emptyEl.hidden = true;
        freshEls.resultsSection.hidden = false;
        freshEls.resultsGrid.innerHTML = products.map(function (p) {
          return cardHtml({ url: p.url, image: p.image, title: p.title, priceText: p.price });
        }).join('');
      })
      .catch(function () {});
  }

  function openOverlay() {
    var els = getOverlayEls();
    if (!els) return;
    els.overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    renderRecent();
    setTimeout(function () { els.input.focus(); }, 50);
  }

  function closeOverlay() {
    var els = getOverlayEls();
    if (!els) return;
    els.overlay.hidden = true;
    document.body.style.overflow = '';
    els.input.value = '';
    els.resultsSection.hidden = true;
    els.emptyEl.hidden = true;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gb-search-open]')) {
      e.preventDefault();
      openOverlay();
      return;
    }
    if (e.target.closest('[data-gb-search-close]')) {
      closeOverlay();
      return;
    }
    if (e.target.closest('[data-gb-search-clear-recent]')) {
      localStorage.removeItem(RECENT_KEY);
      renderRecent();
      return;
    }
    var overlayEl = e.target.closest(overlaySelector);
    if (overlayEl && e.target === overlayEl) {
      closeOverlay();
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-gb-search-input]')) return;
    clearTimeout(debounceTimer);
    var val = e.target.value.trim();
    debounceTimer = setTimeout(function () { runSearch(val); }, 250);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var els = getOverlayEls();
    if (els && !els.overlay.hidden) closeOverlay();
  });

  // Aktuelle Produktseite in "Zuletzt angesehen" speichern
  // (window.gbCurrentProductHandle wird im Liquid-Template gesetzt, falls vorhanden)
  if (window.gbCurrentProductHandle) {
    var ids2;
    try { ids2 = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { ids2 = []; }
    ids2 = ids2.filter(function (h) { return h !== window.gbCurrentProductHandle; });
    ids2.unshift(window.gbCurrentProductHandle);
    localStorage.setItem(RECENT_KEY, JSON.stringify(ids2.slice(0, 12)));
  }

  // Sichtbarer Beweis, dass diese externe Datei geladen UND ausgeführt wurde.
  /// document.documentElement.style.outline = '8px solid limegreen';
})();